import React, { useState } from 'react'
import styles from './signIn.module.css'
import { signIn } from '../../api/signIn'
import { useHistory } from 'react-router'
import { Button, Form, Input, Typography } from 'antd'
import { SignInMFADialog } from './SignInMFADialog'
import { Link } from 'react-router-dom'
import { routePathRestore } from './Restore'
import { routePathCabinet } from '../logined/Cabinet'

interface IFormValues {
	login: string
	password: string
	isRemember: boolean
}

export const SignIn = (): React.ReactElement => {
	const [form] = Form.useForm<IFormValues>()
	const [isDialogVisible, setIsDialogVisible] = useState(false)

	const [isLoading, setIsLoading] = useState(false)
	const [answer, setAnswer] = useState('')

	const history = useHistory()

	async function auth(values: IFormValues) {
		const result = await signIn(values.login, values.password, '')

		if (result.success) {
			history.push(routePathCabinet)
		} else {
			switch (result.errorCode) {
				case 'ALREADY_AUTHORIZED': {
					history.push(routePathCabinet)
					break
				}
				case 'BAD_2FA': {
					setAnswer('Неверный код двухфакторной авторизации')
					setIsDialogVisible(false)
					break
				}
				case 'BAD_LOGIN_OR_PASS': {
					setAnswer('Неверный логин или пароль')
					break
				}
				case 'MFA': {
					setIsDialogVisible(true)
					setAnswer('Введите код двухфакторной авторизации')
					break
				}
				case 'NOT_EXISTS': {
					setAnswer('Аккаунт не существует или не подтверждён')
					break
				}
			}
		}

		setIsLoading(false)
	}

	async function authFromDialog(code: string) {
		if (!code) {
			setAnswer('2FA проверка была отклонена пользователем.')
			setIsLoading(false)
			setIsDialogVisible(false)

			return
		}

		const values = form.getFieldsValue()
		const result = await signIn(values.login, values.password, code)

		if (result.success) {
			history.push(routePathCabinet)
		} else {
			setAnswer('Неверный код двухфакторной авторизации!')
			setIsDialogVisible(false)
		}

		setIsLoading(false)
	}

	return (
		<div className={styles['container']}>
			<Form
				form={form}
				className={styles['sign-in-block']}
				layout="vertical"
				onFinish={(values: IFormValues) => {
					setIsLoading(true)
					void auth(values)
				}}
			>
				<SignInMFADialog visible={isDialogVisible} onFinish={authFromDialog}/>

				<Typography.Title level={3} style={{ marginBottom: '10px' }}>
                    Авторизация
				</Typography.Title>

				<Typography style={{ marginBottom: '10px' }}>
					{answer}
				</Typography>

				<Form.Item
					name="login"
					label="Ник или почта"
					rules={[{ required: true, message: 'Данное поле обязательно!' }]}
				>
					<Input
						placeholder="Введите в это поле ник или почту"
						disabled={isLoading}
					/>
				</Form.Item>
				<Form.Item
					name="password"
					label="Пароль"
					rules={[{ required: true, message: 'Данное поле обязательно!' }]}
				>
					<Input.Password
						placeholder="Введите в это поле пароль"
						disabled={isLoading}
					/>
				</Form.Item>

				<div style={{ display: 'flex', flexDirection: 'row' }}>
					<Link to={routePathRestore} style={{ marginRight: 'auto' }}>
						Забыли пароль?
					</Link>

					<Typography.Link href="https://politcubes.com/actions">
						Ещё нет аккаунта?
					</Typography.Link>
				</div>

				<Form.Item name="submit" style={{ marginTop: '20px' }}>
					<Button htmlType="submit" type="primary" loading={isLoading}>
                        Войти в аккаунт
					</Button>
				</Form.Item>
			</Form>
		</div>
	)
}

export const routePathSignIn = '/auth'
